// import { resumableRefs } from '..';

// export const getFileFromResumableRefs = (uniqueIdentifier: string) => {
//   console.warn('Resumable Refs Files', resumableRefs['video'].files);
//   const resumableRef = Object.values(resumableRefs).find((ref) =>
//     ref.files.some((file) => file.uniqueIdentifier === uniqueIdentifier),
//   );

//   if (!resumableRef) return null;

//   return resumableRef.files.find((file) => file.uniqueIdentifier === uniqueIdentifier);
// };

import { resumableFiles } from "..";

export { removeFileFromResumableFiles } from "..";

export const getFileFromResumableFiles = (uniqueIdentifier: string) => {
  if (!resumableFiles[uniqueIdentifier]) return null;
  return resumableFiles[uniqueIdentifier];
};
